



import BasePageMixin from '@/mixins/base-page-mixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import Form from './params-form.vue';
@Component({
  components: { Form }
})
export default class AddPage extends mixins(BasePageMixin) {}
